








































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import Annoucement from "@/models/porposal/porposal.model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import AnnoucementService from "@/services/porposal.service";
import { PermissionValue } from "@/enums/PermissionValue";
import { RowTable } from "@/typings/BRowTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import { ProposalState } from "@/enums/ProposalState";
import ResearchCenterBasicInformationComponent from "@/components/research-center-basic-information/researchCenterBasicInformation.vue";
import Porposal from "@/models/porposal/porposal.model";
import BaseSelectResearchCenter from "@/components/base/baseSelectResearchCenter/baseSelectResearchCenter.vue";


@Component({
  components: {
    ResearchCenterBasicInformationComponent,
    BaseSelectResearchCenter
  }
})
export default class SendedPorposalTableComponent extends GenericBTable<
  Annoucement
> {
  @Prop() public devuelta!: boolean;
  @Prop() public aprobada!: boolean;
  @Prop() public todas!: boolean;
  @Prop() public estado!: ProposalState;
  porposalState = ProposalState;
  @Prop() public isFondocyt!: boolean;

  annoucementId = null;
  codes = "";
  code = "";
researchCenterId = null;
  created() {
    this.permissionValue = PermissionValue.PROPUESTASFONDOCYT;
    if (this.isFondocyt) {
      this.tableConfig.controller = `Porposal/getSendedByEstado/${this.estado}`;
    } else {
      this.tableConfig.controller = `Porposal/GetSendedToResearchCenter/${this.estado}`;
    }
    this.formatColumns();
  }

  formatColumns() {
    let name = new BTableColumn("name", "table.proposal", true);
    let researchCenter = new BTableColumn(
      "researchCenter/Name",
      "table.researchCenter",
      true
    );
    let dateProperty =
      this.isFondocyt ||
      this.estado == ProposalState.EnviadoFC ||
      this.estado == ProposalState.DevueltoFC
        ? "sendDateToFondocyt"
        : "sendDateToIES";
    let sendDateToIES = new BTableColumn(dateProperty, "table.sendDate", true);

    name.customTemplate = true;
    researchCenter.customTemplate = true;
    name.width = "350";
    researchCenter.width = "350";
    sendDateToIES.type = BTableColumnType.DateTime;

    if (
      this.estado === ProposalState.DevueltoCI ||
      this.estado === ProposalState.RechazadoCI ||
      this.estado === ProposalState.DevueltoFC ||
      this.estado === ProposalState.RechazadoFC
    ) {
      //let motivo = new BTableColumn("motivo", "table.motivo", true);
     // motivo.customTemplate = true;
      this.tableConfig.insertColumns(
        name,
        researchCenter,
        //motivo,
        sendDateToIES
      );
    } else {
      this.tableConfig.insertColumns(name, researchCenter, sendDateToIES);
    }

    this.tableConfig.actions.customTemplate = true;
    this.tableConfig.enableDefaultColumns = false;
  }
  public editProposal(row: Porposal) {
    if (this.isFondocyt) {
      this.$router.push(`/convocatoria/propuesta/${row.id}/fondocyt`);
    } else {
      this.$router.push(`/convocatoria/propuesta/${row.id}`);
    }
  }

  @Watch("annoucementId")
  getByAnnoucement() {
    if(this.annoucementId && this.annoucementId != null)
    this.tableConfig.whereParams = `annoucementId eq  ${this.annoucementId}`;
    this.tableConfig.reload();
  }
   @Watch("researchCenterId")
  getResultResearch(){
    
    if(this.researchCenterId && this.researchCenterId !== null)
    this.tableConfig.whereParams = `researchCenterId eq ${this.researchCenterId}`;
    this.tableConfig.reload();
  }

  @Watch("code")
  getByCode() {
    this.tableConfig.whereParams = `contains(Code, '${this.code}')`;
    this.tableConfig.reload();
  }

  searchByCode(event: any) {
    if (event.keyCode === 13) {
      this.code = this.codes.trim();
    }
  }

  public verOpciones(row: Annoucement) {
    if (this.isFondocyt)
      this.$router.push(`/convocatoria/propuesta/fondocyt/${row.id}/detail`);
    else
      this.$router.push(
        `/convocatoria/propuesta/researchcenter/${row.id}/detail`
      );
  }

  // showRazonUltimoMovimiento(movimientos: any[]) {
  //   return movimientos[movimientos.length - 1].razon;
  // }
}
